import { DatePicker } from 'antd';
import AntDatePicker from './styles/datePicker.style';

export const IsoDatePicker = AntDatePicker(DatePicker);
export const IsoDateRangePicker = AntDatePicker(DatePicker.RangePicker);
